import type { AppApi } from '@wix/wix-data-client-common'
import type { ComponentRef } from '@wix/editor-platform-sdk-types'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import type { Schema } from '@wix/wix-data-schema-types'

interface ReplaceDatasetCollectionParams {
  newCollectionSchema: Schema
  controllerRef: ComponentRef
  fieldMap: Record<string, string>
  appApi: AppApi
  editorSdkProxy: EditorSDK
}

export const replaceDatasetCollection = async ({
  newCollectionSchema,
  controllerRef,
  fieldMap,
  appApi,
}: ReplaceDatasetCollectionParams) => {
  await appApi.changePresetDatasetCollection({
    controllerRef: controllerRef,
    collectionId: newCollectionSchema.id,
    collectionName: newCollectionSchema.displayName,
  })

  const dataset = await appApi.fetchDataset(controllerRef)
  const withHistoryLabel = false
  await appApi.updateDatasetConfig(
    controllerRef,
    {
      ...dataset.config,
      filters: [],
      sorts: [],
    },
    withHistoryLabel,
  )

  await appApi.rebindComponentsToAnotherCollection({
    fieldMap,
    controllerRef,
    newCollectionId: newCollectionSchema.id,
  })
}
